module.exports = __webpack_public_path__ + "static/media/empowerment.ce34fe27.png";